/*
 *
 * Supplier constants
 *
 */

export const DEFAULT_ACTION = 'app/Supplier/DEFAULT_ACTION';
